import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import { Button } from '@speeki/global-ui-components';

import { Loader } from '@components/_universal/Loader/Loader';
import { SuccessTemplate } from '@components/templates/SuccessTemplate/SuccessTemplate';

import { useQueryParam } from '@utils/hooks/useQueryParam';

import { useResetMfaToken } from '@services/AuthService/useResetMfaToken';
import { getPath } from '@services/RouteService/paths';

import { ButtonWrapper } from './ResetMfaPage.styled';

export const ResetMfaPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const companyCode = useQueryParam('code');
    const mfaResetToken = useQueryParam('token');

    const { error, loading } = useResetMfaToken(companyCode, mfaResetToken);

    if (error || !mfaResetToken || !companyCode)
        return <Navigate to={getPath({ path: '/auth/welcome' })} />;

    return (
        <Loader isLoading={loading}>
            <SuccessTemplate
                texts={[t('LOGIN_AGAIN_TO_SETUP_MFA')]}
                title={t('SUCCESSFULL_MFA_RESET')}
            >
                <ButtonWrapper>
                    <Button
                        center
                        onClick={() =>
                            navigate(getPath({ path: '/auth/welcome' }))
                        }
                        testId="button_back-to-welcome-page"
                        variant="primary"
                    >
                        {t('BACK_TO_WELCOME_PAGE')}
                    </Button>
                </ButtonWrapper>
            </SuccessTemplate>
        </Loader>
    );
};
